import React, { Component } from "react";
import ReviewCycleRow from "./ReviewCycleRow";

export default class InformationBox extends Component {
  render() {
    const participantGroups = this.props.participantGroups;
    return (
      <div className="main-info">
        <div className="header-info col-md-12">
          <h4>Information</h4>
        </div>
        {participantGroups.map((participants) => {
          return <ReviewCycleRow participants={participants} />;
        })}
      </div>
    );
  }
}
